import { getMapProctorConfig, MapProctorConfig } from './getMapProctorConfig';

class MapProctorService {
  private static instance: MapProctorService;
  private config: MapProctorConfig | null = null;
  private configPromise: Promise<MapProctorConfig> | null = null;

  private constructor() { }

  public static getInstance(): MapProctorService {
    if (!MapProctorService.instance) {
      MapProctorService.instance = new MapProctorService();
    }
    return MapProctorService.instance;
  }

  private async fetchConfig(): Promise<MapProctorConfig> {
    const result = await getMapProctorConfig();
    if (result.error || !result.baseUrl || !result.apiKey) {
      throw new Error(result.error || 'Failed to fetch MAP proctor configuration');
    }
    return {
      baseUrl: result.baseUrl,
      apiKey: result.apiKey,
    };
  }

  public async getConfig(): Promise<MapProctorConfig> {
    if (this.config) {
      return this.config;
    }

    if (!this.configPromise) {
      this.configPromise = this.fetchConfig();
    }

    this.config = await this.configPromise;
    return this.config;
  }

  public async createStudent(input: {
    first_name: string;
    last_name: string;
    email: string;
    school: string;
    grade: string;
    student_id?: string;
    targetProctor?: string;
  }): Promise<{ success: boolean; studentId?: string; error?: string }> {
    const config = await this.getConfig();

    const response = await fetch(`${config.baseUrl}/api/proctor/create-student`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': config.apiKey,
      },
      body: JSON.stringify(input),
      mode: 'cors',
      credentials: 'omit',
    });

    return await response.json();
  }

  public async assignTest(input: {
    test_key: string;
    student_id: string;
    targetProctor: string;
    accommodations?: string;
  }): Promise<{ success: boolean; error?: string }> {
    const config = await this.getConfig();

    const response = await fetch(`${config.baseUrl}/api/proctor/tests/assign?mode=single`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': config.apiKey,
      },
      body: JSON.stringify(input),
    });

    return await response.json();
  }

  public async getCurrentSession(studentId: string): Promise<{
    session?: {
      testSessionId: string | null;
      name: string | null;
      password: string | null;
    };
    error?: string;
  }> {
    const config = await this.getConfig();

    const response = await fetch(
      `${config.baseUrl}/api/proctor/current-session?student_id=${studentId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': config.apiKey,
        },
      }
    );

    return await response.json();
  }
}

export default MapProctorService;
